export { default } from './useInterval'
